export default __webpack_public_path__ + "static/media/live_typing.69fb4e26.JPG";